import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { componentKey, setAssigneeList, setClientList, setExportFile, setInvitedAssigneeList, setLoadingState, setNoticeDetail, setNoticeDocumentList, setNoticeNotes, setNoticeTasksList, setPayerDetails, setTaskStatusList } from './ViewNoticeSectionSlice';
import NoticesDataService from '../../../../services/NoticesDataService';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';

export const { downloadNoticeDocument, downloadTaskDocument, saveTask, removeNoticeTask, getNotice, getTaskList, removeNoticeNote, getAssigneeList, inviteClient, saveNoticeNote, removeNoticeDocument, uploadNoticeDocument, getTaskStatusList, removeTaskNote, removeTaskDocument, saveTaskNote, uploadTaskDocument } = {
    getNotice: (payload) => {
        return {
            type: "VIEW_NOTICES/GET_NOTICE_DETAILS",
            payload: payload
        }
    },
    getTaskList: (payload) => {
        return {
            type: "VIEW_NOTICES/GET_NOTICE_TASK_LIST",
            payload: payload
        }
    },
    removeNoticeNote: (payload) => {
        return {
            type: "VIEW_NOTICES/REMOVE_NOTICE_NOTE",
            payload: payload
        }
    },
    getAssigneeList: (payload) => {
        return {
            type: "VIEW_NOTICES/GET_ASSIGNEE_LIST",
            payload: payload
        }
    },
    inviteClient: (payload) => {
        return {
            type: "VIEW_NOTICES/INVITE_CLIENT",
            payload: payload
        }
    },
    saveNoticeNote: (payload) => {
        return {
            type: "VIEW_NOTICES/SAVE_NOTICE_NOTE",
            payload: payload
        }
    },
    saveTaskNote: (payload) => {
        return {
            type: "VIEW_NOTICES/SAVE_TASK_NOTE",
            payload: payload
        }
    },
    removeNoticeDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/REMOVE_NOTICE_DOCUMENT",
            payload: payload
        }
    },
    uploadNoticeDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/UPLOAD_NOTICE_DOCUMENT",
            payload: payload
        }
    },
    uploadTaskDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/UPLOAD_TASK_DOCUMENT",
            payload: payload
        }
    },
    getTaskStatusList: (payload) => {
        return {
            type: "VIEW_NOTICES/GET_TASK_STATUS_LIST",
            payload: payload
        }
    },
    removeTaskNote: (payload) => {
        return {
            type: "VIEW_NOTICES/REMOVE_TASK_NOTE",
            payload: payload
        }
    },
    removeTaskDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/REMOVE_TASK_DOCUMENT",
            payload: payload
        }
    },
    saveTask: (payload) => {
        return {
            type: "VIEW_NOTICES/SAVE_TASK",
            payload: payload
        }
    },
    removeNoticeTask: (payload) => {
        return {
            type: "VIEW_NOTICES/REMOVE_NOTICE_TASK",
            payload: payload
        }
    },
    downloadTaskDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/DOWNLOAD_NOTICE_TASK_DOCUMENT",
            payload: payload
        }
    },
    downloadNoticeDocument: (payload) => {
        return {
            type: "VIEW_NOTICES/DOWNLOAD_NOTICE_DOCUMENT",
            payload: payload
        }
    },
}


function* getNoticeAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.getNotice(action.payload);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in fetching notice",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setNoticeDetail(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* getTaskListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.getTaskList(action.payload);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in fetching notice task list",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setPayerDetails(response.data.Data.PayerDetail))
            yield put(setNoticeNotes(response.data.Data.NoticeNotes))
            yield put(setNoticeTasksList(response.data.Data.NoticeTasksList))
            yield put(setNoticeDocumentList(response.data.Data.NoticeDocumentList))
            yield put(setClientList(response.data.Data.ClientList))
            yield put(setInvitedAssigneeList(response.data.Data.InvitedAssigneeList))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* removeNoticeNoteAsync(action) {
    try {
        const { NoticeNoteID, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.removeNoticeNote(NoticeNoteID);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in removing notice note",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* getAssigneeListAsync(action) {
    try {
        const { payerId, noticeid, invitedAssigneeList } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.addNoticeGetAssigneeByPayerId({ payerId });
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in fetching assignee list",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setAssigneeList(response.data.Data.filter(assignee => !invitedAssigneeList.includes(parseInt(assignee.value)))
                .map(assignee => ({ label: assignee.label, value: assignee.value, checked: false }))));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* inviteClientAsync(action) {
    try {
        const { data, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.inviteClient(data);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in inviting client",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getNoticeAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* saveNoticeNoteAsync(action) {
    try {
        const { data, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.saveNoticeNote(data);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in saving Notice Note",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* saveTaskNoteAsync(action) {
    try {
        const { data, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.saveTaskNote(data);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in saving Task Note",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* removeNoticeDocumentAsync(action) {
    try {
        const { NoticeDocumentID, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.removeNoticeFile(NoticeDocumentID);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in removing Notice Document",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* uploadNoticeDocumentAsync(action) {
    try {
        const { NoticeID, uploadFile, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const formData = new FormData();
        formData.append("file", uploadFile);
        const response = yield NoticesDataService.uploadNoticeFile(NoticeID, formData);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Uploading Notice Document",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* uploadTaskDocumentAsync(action) {
    try {
        const { NoticeTaskID, uploadFile, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const formData = new FormData();
        formData.append("file", uploadFile);
        const response = yield NoticesDataService.uploadTaskFile(NoticeTaskID, formData);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Uploading Task Document",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* getTaskStatusListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.getStatusList();
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Getting Task Status",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setTaskStatusList(response.data.Data.map(status => ({ label: status.label, value: status.value }))))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* removeTaskNoteAsync(action) {
    try {
        const { NoticeTaskNoteID, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.removeTaskNote(NoticeTaskNoteID);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Removing Task Note",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* removeTaskDocumentAsync(action) {
    try {
        const { NoticeTaskDocumentID, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.removeTaskDocument(NoticeTaskDocumentID);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Removing Task Document",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* removeNoticeTaskAsync(action) {
    try {
        const { NoticeTaskID, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.removeNoticeTask(NoticeTaskID);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in Removing Notice Task",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* saveTaskAsync(action) {
    try {
        const { noticeDetails, noticeid } = action.payload;
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.saveNoticeTask(noticeDetails);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in saving Task",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getTaskListAsync, { payload: { noticeid } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* downloadTaskDocumentAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.downloadTaskDocument(action.payload);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in saving Task",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setExportFile(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* downloadNoticeDocumentAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield NoticesDataService.downloadNoticeDocument(action.payload);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in saving Task",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setExportFile(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getNotice().type, getNoticeAsync),
        takeLatest(getTaskList().type, getTaskListAsync),
        takeLatest(removeNoticeNote().type, removeNoticeNoteAsync),
        takeLatest(removeTaskNote().type, removeTaskNoteAsync),
        takeLatest(getAssigneeList().type, getAssigneeListAsync),
        takeLatest(inviteClient().type, inviteClientAsync),
        takeLatest(saveNoticeNote().type, saveNoticeNoteAsync),
        takeLatest(saveTaskNote().type, saveTaskNoteAsync),
        takeLatest(removeNoticeDocument().type, removeNoticeDocumentAsync),
        takeLatest(removeTaskDocument().type, removeTaskDocumentAsync),
        takeLatest(uploadNoticeDocument().type, uploadNoticeDocumentAsync),
        takeLatest(uploadTaskDocument().type, uploadTaskDocumentAsync),
        takeLatest(getTaskStatusList().type, getTaskStatusListAsync),
        takeLatest(saveTask().type, saveTaskAsync),
        takeLatest(removeNoticeTask().type, removeNoticeTaskAsync),
        takeLatest(downloadTaskDocument().type, downloadTaskDocumentAsync),
        takeLatest(downloadNoticeDocument().type, downloadNoticeDocumentAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);